import { FeedbackMessages } from '@hendrx/lms/constants';
import { ElementType } from 'react';

export enum Feedbacks {
  Automatic = 'automatic',
  Check = 'check',
  None = 'none'
}

export type RandomizedFeedback = {
  RandomizedIcon: ElementType;
  randomizedText: string;
  withAnimation: boolean;
};

export type FeedbackMessageType = `${FeedbackMessages}`;

export const getFeedbackMessageType = ({
  allPossibleRightAnswersCount,
  rightAnswersCount,
  wrongAnswersCount,
  feedback
}: {
  allPossibleRightAnswersCount: number;
  rightAnswersCount: number;
  wrongAnswersCount: number;
  feedback: `${Feedbacks}` | null;
}): FeedbackMessageType | null => {
  // right
  const noCorrectAnswer = rightAnswersCount === 0;
  const notAllCorrectAnswers = rightAnswersCount > 0 && rightAnswersCount < allPossibleRightAnswersCount;
  const allCorrectAnswers = rightAnswersCount === allPossibleRightAnswersCount;
  const someCorrectAnswers = notAllCorrectAnswers || allCorrectAnswers;
  // wrong
  const noWrongAnswer = wrongAnswersCount === 0;
  const someWrongAnswers = wrongAnswersCount > 0;

  if (noCorrectAnswer && noWrongAnswer && feedback !== Feedbacks.Automatic) {
    return FeedbackMessages.NoAnswer;
  } else if (noCorrectAnswer && someWrongAnswers) {
    return FeedbackMessages.OnlyWrongAnswers;
  } else if (notAllCorrectAnswers && noWrongAnswer) {
    return FeedbackMessages.NotAllCorrectAndNoWrongAnswers;
  } else if (someCorrectAnswers && someWrongAnswers) {
    return FeedbackMessages.SomeCorrectAndSomeWrongAnswers;
  } else if (allCorrectAnswers && noWrongAnswer) {
    return FeedbackMessages.OnlyAllCorrectAnswers;
  }

  return null;
};

export const getFeedbackMessageTypeByScore = (score: number | undefined | null, isAnswered: boolean) => {
  if (isAnswered === false) {
    return FeedbackMessages.NoAnswer;
  } else if (isAnswered && typeof score === 'number') {
    if (score === 0) {
      return FeedbackMessages.OnlyWrongAnswers;
    } else if (score > 0 && score < 100) {
      return FeedbackMessages.SomeCorrectAndSomeWrongAnswers;
    } else if (score === 100) {
      return FeedbackMessages.OnlyAllCorrectAnswers;
    }
  }
  return null;
};
